var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.15259,
    y: 6.31506,
    width: 4.61497,
    height: 7.35562,
    fill: "#FF5F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62795 9.99349C9.62679 8.55836 10.3019 7.20241 11.4588 6.31633C9.49344 4.80909 6.67116 5.02863 4.97535 6.82067C3.27954 8.6127 3.27954 11.3756 4.97535 13.1676C6.67116 14.9596 9.49344 15.1792 11.4588 13.672C10.3015 12.7856 9.62638 11.4291 9.62795 9.99349Z",
    fill: "#EB001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7659 12.7737V13.0794H18.7336V12.7737H18.6648V12.7104H18.8391V12.7737H18.7659ZM19.1042 12.7104V13.0794H19.0676V12.8L19.0105 13.0398H18.9709L18.9138 12.8V13.0794H18.8757V12.7104H18.9284L18.9899 12.974L19.0515 12.7104H19.1042Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2147 9.99353C19.2147 11.7845 18.1667 13.4182 16.516 14.2008C14.8653 14.9834 12.9015 14.7776 11.4587 13.6707C12.6151 12.7839 13.2903 11.4281 13.2903 9.99288C13.2903 8.55767 12.6151 7.20189 11.4587 6.31507C12.9015 5.20816 14.8653 5.00231 16.516 5.78494C18.1667 6.56757 19.2147 8.20128 19.2147 9.99223V9.99353Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.620a9958020f69337e1ab32358cdbb96.svg";
export { ForwardRef as ReactComponent };